import React from 'react';

var BodyCell = function BodyCell(_ref) {
  var index = _ref.index,
      row = _ref.row,
      value = _ref.value;
  return /*#__PURE__*/React.createElement("td", index === 0 ? {
    scope: 'row'
  } : {}, value);
};

export default BodyCell;